<template>
  <component
    :is="getContainerType"
    v-if="shouldRenderConfig"
    v-show="alwaysShow || getShowUpload"
    :class="getClassName"
  >
    <appConnectButton></appConnectButton>
    <appUpload
      v-for="pp in getProductPartsNamesForUpload"
      :key="pp.code"
      :propsData="pp"
      :alwaysShow="alwaysShow"
    ></appUpload>
  </component>
</template>
<script>
import { useConfigStore } from "@/stores/modules/config";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getProductPartsNamesForUpload"]),
    ...mapState(useConfigStore, ["getShowUpload"])
  },
  props: ["hideContainer", "alwaysShow"]
};
</script>
